import Vue from "vue";
import Vuelidate from "vuelidate";
// import VueGtm from "vue-gtm";

import App from "./App.vue";
import router from "./router";
import store from "@state/store";

import "@components/_globals.base";
// import EventsGtm from "./plugins/events-gtm";
import gtm from "@src/plugins/gtm";
import popup from "@src/plugins/popup";
import ofdb from "@src/plugins/ofdb";
import tracking from "@src/plugins/tracking";

Vue.config.productionTip = false;

Vue.use(Vuelidate);
// if (searchToObject(window.location.search).gtag) {
//   window.sessionStorage.setItem(
//     "gtag",
//     searchToObject(window.location.search).gtag
//   );
// }
// const gtagSession = window.sessionStorage.getItem("gtag");
// const gtag = gtagSession || "GTM-MHDFWVT";

// Vue.use(VueGtm, {
//   id: process.env.VUE_APP_GTM,
//   enable: true,
//   debug: process.env.NODE_ENV === "development",
//   vueRouter: router,
//   ignoredViews: ["loadingApp"],
// });

// Vue.use(VueAnalytics, {
//   id: process.env.VUE_APP_GA_ID,
//   router,
//   ignoreRoutes: ["/"],
//   autoTracking: {
//     exception: true,
//   },
//   debug: {
//     enabled: !process.env.NODE_ENV === "development", // default value
//     trace: false, // default value
//     sendHitTask: true, // default value
//   },
//   ecommerce: {
//     enabled: process.env.NODE_ENV === "development",
//     enhanced: process.env.NODE_ENV === "development",
//   },
// });

// Vue.use(EventsGtm);
let eventsConfig = {
  ignoreViews: ["loadingApp", "checkoutFixa"],
  scope: process.env.VUE_APP_SCOPE,
};

if (process.env.VUE_APP_SCOPE.toLowerCase() !== "eventsfamilia")
  eventsConfig = { ...eventsConfig, vueRouter: router };

Vue.use(gtm, eventsConfig);
Vue.use(popup);
Vue.use(ofdb);
Vue.use(tracking);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
